module.exports = {

  title: "Search words analyzer",

  dialog: {
    loadView: {
      title: "Load query with filters"
    },
    saveView: {
      title: "Save query with filters"
    }
  },

  saveCSV: "CSV",
  saveTSV: "TSV",
  computing: {
    title: "Computing...",
    text: "Please wait."
  },
  filtering: {
    title: "Filtering...",
    text: "Please wait."
  },
  empty: "No results found",
  failed: "Processing failed.",

  query: {
    title: "Query",
    filterResults: "Filter results",
    columns: "Words Columns",
    number: "Words count:",
    min: "Min",
    max: "Max",
    isNotNumber: "Input is not a number!",
    ignoreSpecial: "Ignore special characters",
    ignoreCase: "Ignore case"

  },

  filename: "file: ",

  endInfo: {
    'download': ({ allRows, visibleRows }) => `There is ${allRows - visibleRows} more words. You can download full table.`,
    'premium': ({ allRows, visibleRows }) => `There is ${allRows - visibleRows} more words. To see them all you need premium account.`
  }

}



// WEBPACK FOOTER //
// ../i18n/en/words.js